import { render, staticRenderFns } from "./lead-details-modal.vue?vue&type=template&id=62ebd83e&scoped=true"
import script from "./lead-details-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./lead-details-modal.vue?vue&type=script&setup=true&lang=js"
import style0 from "./lead-details-modal.vue?vue&type=style&index=0&id=62ebd83e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62ebd83e",
  null
  
)

export default component.exports